import { PAYEX_URL } from 'constants/config';
import type { AuthorizedDealer } from 'models/authorizedDealer';
import { fetch } from 'services/apiV3/fetch';

type AuthorizedDealerRequestBody = {
  sender_country: string;
  recipient_id: string;
  offer: {
    id: string;
  };
};

const indiaAuthorizedDealer = {
  fetch: (body: AuthorizedDealerRequestBody) =>
    fetch(`${PAYEX_URL}/india/authorized_dealer`, {
      method: 'POST',
      body: JSON.stringify(body),
    }) as Promise<AuthorizedDealer>,
};

export { type AuthorizedDealerRequestBody, indiaAuthorizedDealer };
